function Image({ src, containerCss, imgCss }) {
  return (
    <div className={containerCss}>
      <img className={imgCss} alt="" src={src}></img>
    </div>
  );
}

Image.defaultProps = {
  containerCss: "w-full h-full",
};

export default Image;
